import { useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { Stack } from '@mui/system';
import Salary from './Salary';
import User from './User';

const UserPage = () => {
  const [selectedTab, setSelectedTab] = useState('1');
  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Stack direction="column" sx={{ height: 1 }}>
      <TabContext value={selectedTab}>
        <TabList onChange={handleChange}>
          <Tab label="Users" value="1" />
          <Tab label="Salary" value="2" />
        </TabList>
        <TabPanel sx={{ p: 0, height: 1 }} value="1">
          <User />
        </TabPanel>

        <TabPanel sx={{ p: 0, height: 1 }} value="2">
          <Salary />
        </TabPanel>
      </TabContext>
    </Stack>
  );
};

export default UserPage;
